import { IonHeader, IonProgressBar, IonToolbar } from "@ionic/react";
import { useSelector } from "react-redux";
import { RootState } from "../../data/store";
import { useTranslation } from "react-i18next";

interface HeaderProps {
    children: React.ReactNode
}

const Header: React.FC<HeaderProps> = ({ children }: HeaderProps) => {
    const dbLoading: boolean = useSelector((state: RootState) => state.db.dbLoading);
    const dbUpdating: boolean = useSelector((state: RootState) => state.db.dbUpdating);
    const isOnline: boolean = useSelector((state: RootState) => state.network.isOnline);
    const { t } = useTranslation();

    return (
        <IonHeader>
            <IonToolbar>
                {children}
                {(dbUpdating || dbLoading) && <IonProgressBar type="indeterminate"></IonProgressBar>}
            </IonToolbar>
            {!isOnline && <div className='offlineIndicator'>{t("Keine Verbindung")}</div>}
            {/* {dbLoading && <div className='offlineIndicator'>Daten werden im Hintergrund geladen</div>}
            {dbUpdating && <div className='offlineIndicator'>Daten werden im Hintergrund aktualisiert</div>} */}
        </IonHeader>
    )
}

export default Header;